import { KLAVIYO_DEFAULT_METRIC_NAME } from "@babackapp/tracking-status-registry";
import { FormField } from "@babackapp/ui/components/form";
import { Input } from "@babackapp/ui/components/input";
import { useTranslation } from "react-i18next";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import { useNodeFormPath } from "../../hooks/use-node-form-path";
import { PanelContent } from "../../lib/panel/panel-content";

export function PanelKlaviyoEvent() {
  const { t } = useTranslation("trackoffice");
  const form = useWorkflowForm();

  const metricNamePath = useNodeFormPath("config.metricName");

  if (!metricNamePath) {
    return null;
  }

  return (
    <PanelContent
      title={t("workflowsEditor.klaviyoEvent.panelTitle", "Klaviyo Event")}
    >
      <div className="space-y-4">
        <p className="text-xs text-muted-foreground">
          {t(
            "workflowsEditor.klaviyoEvent.description",
            "This node sends an event to Klaviyo with the current tracking status. Use this event in Klaviyo to trigger flows (e.g. post-purchase emails).",
          )}
        </p>

        <div className="flex flex-col gap-1.5">
          <span className="font-medium text-xs text-muted-foreground">
            {t("workflowsEditor.klaviyoEvent.metricNameLabel", "Event name")}
          </span>
          <FormField
            control={form.control}
            name={metricNamePath}
            render={({ field }) => (
              <Input
                {...field}
                value={(field.value as string | undefined) ?? ""}
                placeholder={KLAVIYO_DEFAULT_METRIC_NAME}
                className="text-sm"
              />
            )}
          />
          <span className="text-xs text-muted-foreground">
            {t(
              "workflowsEditor.klaviyoEvent.metricNameHelp",
              "Name of the metric Klaviyo receives. Leave empty to use the default.",
            )}
          </span>
        </div>
      </div>
    </PanelContent>
  );
}
